import {Colors} from '../../../../theme/colours'
import {type IconStyleProps} from '../icon.types'
import {RotatingContainer} from './dropdown-icon.styled'

type DropdownIconProps = {
    isSelected: boolean
    rotateFromSide?: boolean
    color?: string
} & Omit<IconStyleProps, 'color'>

export function DropdownIcon({
    isSelected,
    color = Colors.blue2,
    rotateFromSide = false,
}: DropdownIconProps) {
    return (
        <RotatingContainer $isSelected={isSelected} $rotateFromSide={rotateFromSide}>
            <svg
                aria-hidden="true"
                width="8"
                height="5"
                viewBox="0 0 8 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{width: '14px'}}
            >
                <path
                    d="M1.3542 1.43543L4.0792 4L6.8042 1.43543"
                    stroke={color}
                    strokeWidth="1.71429"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </RotatingContainer>
    )
}
